<template>
    <div class="calendar-cpt-support-doc">
        <UiChecklist 
            :options="documentOptions"
            @change="onDocumentOptionChanged"
        />
        <UiStringlist 
            :records="documentRecords"
            @change="changeDocumentRecord"
            @add="addDocumentRecord"
            @remove="removeDocumentRecord"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiChecklist from '../../ui/UiChecklist.vue';
import UiStringlist from '../../ui/UiStringlist.vue';

export default {
    name: "CalendarCptSupportDoc",
    components: {
        UiChecklist,
        UiStringlist,
    },
    props: ["value", "templateStage"],
    data () {
        return {
            counter: 0,
        };
    },
    computed: {
        documents() {
            return this.value || [];
        },
        documentRecords() {
            return [...this.documents]
                .filter(document => !document.TPL_DOC_ID)
                .map(document => ({ id: document.ID, value: document.NAME }));
        },
        templateDocuments() {
            return this.templateStage.DOCUMENTS || [];
        },
        templateDocumentOptions() {
            if (this.templateStage) {
                return [...this.templateDocuments]
                    .map(templateDocument => ({ 
                        id: templateDocument.ID,
                        label: templateDocument.NAME,
                     }));
            }
            return [];
        },
        documentOptions() {
            return [...this.templateDocumentOptions]
                .map(templateDocumentOption => ({
                    ...templateDocumentOption,
                    checked: this.documents.find(document => document.TPL_DOC_ID == templateDocumentOption.id)
                }));
        },  
        ...mapGetters(["calendarItems"])
    },
    methods: {
        getNewDocumentUniqueId() {
            this.counter++;
            return 'n'+this.counter+'_'+Math.ceil(Math.random()*9999999); 
        },
        addDocumentRecord() {
            // Добавление нового документа
            this.$emit('input', [
                ...this.documents,
                {
                    ID: this.getNewDocumentUniqueId(),
                    NAME: '',
                }
            ]);
        },
        changeDocumentRecord(id, value) {
            this.$emit('input', 
                this.documents
                    .map(document => {
                        if (document.ID == id) {
                            return {
                                ...document, 
                                NAME: value,
                            };
                        } 
                        return document;
                    })
            );
        },
        removeDocumentRecord(id) {
            this.$emit('input', this.documents.filter(document => document.ID != id));
        },
        onDocumentOptionChanged(id, value) {
            if (value) {
                const templateDocument = this.templateDocuments
                    .find(templateDocument => templateDocument.ID == id);
                
                if (templateDocument) {
                    // Добавление нового документа
                    this.$emit('input', [
                        ...this.documents,
                        {
                            ID: this.getNewDocumentUniqueId(),
                            NAME: templateDocument.NAME,
                            TPL_DOC_ID: templateDocument.ID,
                        }
                    ]);
                }
            } else {
                this.$emit('input', this.documents.filter(document => document.TPL_DOC_ID != id));
            }
        },
    }
};
</script>

<style scoped>
.calendar-cpt-support-doc {
    margin-bottom: 12px;
}
</style>
